<template>
  <GcBaseLayout
    title="Suppliers"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :backButtonEnable="false"
  >
    <template #headerContent>
      <GcHeaderContentStatic
        title="Suppliers"
        :screenName="'Suppliers - Transactions'"
      />
    </template>

    <div class="css-v2 grid-report">
      <gc-data-grid-report
        v-if="report.dataSourceConfig"
        :exportFileName="report.exportFileName"
        :dataSourceConfig="reportDataSourceConfig"
        :columns="columns"
        :gridOptions="gridOptions"
        :persistenceKey="persistenceKey"
        :heightPadding="20"
        :gridToolbar="gridToolbar"
      >
      </gc-data-grid-report>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import GcDataGridReport from "@/components/gc-data-grid-report";
import { ScreenLayoutService } from "@/_services/api/reports/screen-layout.service";
import { CommonStorage } from "../../_services/storage";
import {
  SuppliersTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/suppliers/suppliers-tabs";

export default {
  props: {
    /**
     * contains report configurations
     */
    reportConfig: {
      type: Object,
      default: undefined,
    },
  },
  mixins: [RouteMixin],
  components: {
    GcDataGridReport,
  },

  data() {
    return {
      persistenceKey: "supplier-transaction",
      backButtonRoute: `/supplier`,
      model: {
        Code: "",
        Name: "",
      },
      report: {
        title: "",
        exportFileName: "",
        featureCode: "",
        dataSourceConfig: null,
        columns: [],
      },
      gridOptions: {
        noDataMessage: {
          addNew: {
            class: "no-data",
            title: "No Transactions",
            message: "Currently there are no transactions for suppliers.",
          },
        },
      },
      gridToolbar: {
        search: false,
        columnChooser: true,
        export: true,
        openFilter: true,
        filterOnEnter: true,
      },
    };
  },
  computed: {
    tabs() {
      // return [
      //   {
      //     text: "All",
      //     path: `/supplier`,
      //     applicationFeatureCode: "Supplier",
      //   },
      //   {
      //     text: "Transactions",
      //     path: `/supplier-transaction`,
      //     applicationFeatureCode: "SupplierTransactionHistory",
      //   },
      //   {
      //     text: "Awaiting Payments",
      //     path: `supplier/awaiting-payment-list`,
      //     applicationFeatureCode: "SupplierTransactions",
      //   },
      //   {
      //     text: "Batch Payments",
      //     path: `/supplier/batch-payment-list`,
      //     applicationFeatureCode: "SupplierTransactions",
      //   },
      // ];
      return SuppliersTabs;
    },
    reportDataSourceConfig() {
      var config = this.report.dataSourceConfig;
      // config.filter = [["SupplierCode", "=", this.model.Code]];
      return config;
    },

    columns() {
      var cols = this.report.columns;

      return cols;
    },
  },

  async created() {
    CommonStorage.clear("go_back_route");
    this.selectedIndex = GetIndexByTabName("Transactions");
    let response = await ScreenLayoutService.getByRoute(
      "supplier-transaction-history"
    );
    if (response.data.value) {
      this.report = JSON.parse(response.data.value[0].Definition);
    }
  },
  methods: {},
};
</script>
